import { type RowData } from '@tanstack/react-table';

import type { DataTableOptions } from '../types/table.types.js';
import type { DataTableDownloadHeaderContext } from './download-types.js';

/**
 * Configuration hook for download of the DataTable.
 * @internal
 */
export function useDownloadData<TData extends RowData>(
  props: {
    onDownloadData?: (
      subset: 'all' | 'page' | 'selected',
      excludedColumns?: string[],
    ) => void;
    formatDownloadHeader?: (
      context: DataTableDownloadHeaderContext,
    ) => string | undefined;
  },
  options: DataTableOptions<TData>,
): void {
  options.onDownloadData = props.onDownloadData;
  options.formatDownloadHeader = props.formatDownloadHeader;
}
